module.exports = __webpack_public_path__ + "img/circle_public relations.7bae661c.svg";